import { isDebug } from "@base/BuildEnvironment";
import { IVec3, Vec3 } from "@base/math/Vec3";
import { PartialRecord } from "@base/util/TypeUtil";
import { ConfiguratorItemData, expect3d, ProductData3d } from "@biz/definitions/IVariantData3d";
import { createCurtainBizImpl } from "@biz/items/curtain/CurtainBizImpl";
import { createFenceBizImpl } from "@biz/items/fence/FenceBizImpl";
import { createGroundBizImpl } from "@biz/items/ground/GroundBizImpl";
import { createGroupBizImpl } from "@biz/items/group/GroupBizImpl";
import { createLoungeBizImpl } from "@biz/items/lounge/LoungeBizImpl";
import { createModelBizImpl } from "@biz/items/model/ModelBizImpl";
import { createModelProductBizImpl } from "@biz/items/model/ModelProductBizImpl";
import { createNetBizImpl } from "@biz/items/net/NetBizImpl";
import { createOpeningBizImpl } from "@biz/items/opening/OpeningBizImpl";
import { IBizItemInterface } from "@biz/items/product/IBizItemInterface";
import { createSunRaffBizImpl } from "@biz/items/raff/RaffBizImpl";
import { createRoofBizImpl } from "@biz/items/roof/RoofBizImpl";
import { createSandboxBizImpl } from "@biz/items/sandbox/SandboxBizImpl";
import { createSunSailBizImpl } from "@biz/items/sunSail/SunSailBizImpl";
import { createWallBizImpl } from "@biz/items/wall/WallBizImpl";
import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";

const bizItemImpls: PartialRecord<ConfiguratorItemData["itemType"], IBizItemInterface> = {}
export function getBizImpl(type: ConfiguratorItemData["itemType"]): IBizItemInterface {
  if (!bizItemImpls[type]) {
    bizItemImpls[type] = createBizImpl(type);
  }
  return bizItemImpls[type]!;
}

function createBizImpl(type: ConfiguratorItemData["itemType"]): IBizItemInterface {
  switch (type) {
    case "sunSail": return createSunSailBizImpl();
    case "raff": return createSunRaffBizImpl();
    case "curtain": return createCurtainBizImpl();
    case "lounge": return createLoungeBizImpl();
    case "modelProduct": return createModelProductBizImpl();
    case "net": return createNetBizImpl();
    case "model": return createModelBizImpl();
    case "ground": return createGroundBizImpl();
    case "wall": return createWallBizImpl();
    case "fence": return createFenceBizImpl();
    case "roof": return createRoofBizImpl();
    case "opening": return createOpeningBizImpl();
    case "sandbox": return createSandboxBizImpl();
    case "group": return createGroupBizImpl();
  }
  if (isDebug()) {
    throw new Error(`createImpl: No implementation for item type ${type}`);
  }
  return createDefaultBizImpl(type);
}

export function createDefaultBizImpl(itemType: ConfiguratorItemData["itemType"]): IBizItemInterface {
  return {
    calc3d(_product: ProductData3d, _slc: ICalcContext): ICalculatedProductResult {
      throw new Error("Not a product " + itemType)
    },
    calcCloneOffset(item: ConfiguratorItemData): IVec3 {
      expect3d(item, itemType);
      return Vec3.from(2, 0, 0);
    },
    cloneItem(_item: ConfiguratorItemData, _options?: { newId?: string; parentId?: string; cloneOffset?: IVec3 }): { item: ConfiguratorItemData, children?: ConfiguratorItemData[] } | undefined {
      throw new Error("createDefaultBizImpl.cloneItem " + itemType)
    }
  }
}